// DestaquesCore.tsx
import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';

import { getUser } from '../../modules/contexts/Auth/RequireAuth';
import { useNivelCriticidade } from '../../services/enum/useNivelCriticidade';
import httpClient, { isHttpError } from '../../services/httpClient';
import { getAllDestaquesPorEntidade } from '../../services/tabelasCompartilhadas/destaqueService';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../utils/swal';
import BarraInferiorBotoes from '../BarraInferiorBotoes';
import BarraSubAbas from '../BarraSubAbas';
import BoxConteudo from '../BoxConteudo';
import ContainerConteudo from '../ContainerConteudo';
import CustomCol from '../CustomCol';
import { CustomSwal } from '../CustomFeedback/CustomSwal';
import CustomRow from '../CustomRow';
import Input from '../InputNew';
import Select from '../InputNew/Select';
import StyledLink from '../Link';
import Log from '../Log/Log';
import SubAbas from '../SubAbas';
import Tabela from '../Tabela';
import UploadMultiple from '../Upload/multiple';
import WorkspaceBotoes from '../WorkspaceBotoes';
import WorkspaceFicha from '../WorkspaceFicha';
import {
  headersDestaques,
  valoresExibidosDestaques,
} from './auxiliarDestaques';
import CustomOffcanvas from '../CustomOffcanvas';

interface Props {
  tab: string;
  id_tab: string;
  retorno: string;
  arquivo_export: string;
  fieldObject: any;
  subAbas: any;
  entity: string;
}

type FormDestaqueType = {
  id: number;
  usuarioId: number;
  tabId: any;

  nivelCriticidade: number;
  dataDestaque: string;
  titulo: string;
  descricao: string;
  link: string;
  observacoes: string;
};

const DestaquesComponente: React.FC<Props> = ({
  tab,
  id_tab,
  retorno,
  arquivo_export,
  fieldObject,
  subAbas,
  entity,
}) => {
  const user = getUser();
  const userID = user.sub;
  const NivelCriticidade = useNivelCriticidade();

  //////STATES
  const [showModal, setShowModal] = useState(false);
  const [logData, setLogData] = useState<any>();
  const [destaqueId, setDestaqueId] = useState('');
  const [updating, setUpdating] = useState(false);
  const [data, setData] = useState<any[]>();
  const [formDestaque, setFormDestaque] = useState<FormDestaqueType>({
    id: 0,
    descricao: '',
    nivelCriticidade: 0,
    observacoes: '',
    titulo: '',
    link: '',
    dataDestaque: '',
    tabId: parseInt(id_tab, 10),
    usuarioId: userID,
  });

  //////OUTROS
  const iconeModal = 'account_tree';
  const tituloModal = updating ? 'Atualizar Registro' : 'Novo Registro';

  //////FETCH DATA
  const fetchData = async () => {
    try {
      const destaques = await getAllDestaquesPorEntidade(tab, Number(id_tab));
      setData(destaques);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };

  useEffect(() => {
    if (id_tab !== 'undefined') fetchData();
  }, [id_tab]);

  //////TABLE E OFFCANVAS
  const tableData =
    data?.map((item) => ({
      id: item.id,
      nivelCriticidade: NivelCriticidade[item.nivelCriticidade]?.label,
      dataDestaque: formatDateSimp(item.dataDestaque),
      titulo:
        item.titulo && item.titulo.length > 100
          ? item.titulo.substring(0, 100) + '...'
          : item.titulo || '',
      descricao:
        item.descricao && item.descricao.length > 200
          ? item.descricao.substring(0, 200) + '...'
          : item.descricao || '',
    })) || [];

  const exportData =
    data?.map((item) => ({
      id: item.id,
      [`${tab}`]: item[tab]?.id,
      dataRegistro: item.dataRegistro,
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      dataUltimaVisualizacao: item.dataUltimaVisualizacao,
      usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      usuarioAtualizacao: formataNomeMeioSiglas(
        item.usuarioAtualizacao.nomeCompleto,
      ),
      usuarioUltimaVisualizacao: formataNomeMeioSiglas(
        item.usuarioUltimaVisualizacao.nomeCompleto,
      ),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      nivelCriticidade: NivelCriticidade[item.nivelCriticidade]?.label,
      titulo: item.titulo,
      descricao: item.descricao,
      dataDestaque: item.dataDestaque,
      link: item.link,
      observacoes: item.observacoes,
    })) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormDestaque({
      id: 0,
      descricao: '',
      nivelCriticidade: 0,
      observacoes: '',
      titulo: '',
      link: '',
      dataDestaque: '',
      tabId: parseInt(id_tab, 10),
      usuarioId: userID,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setDestaqueId(id);
    setUpdating(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const formatDateLocal = (iso: string) => iso?.split('T')[0];
      setFormDestaque({
        id: itemSelecionado.id,
        nivelCriticidade: itemSelecionado.nivelCriticidade,
        titulo: itemSelecionado.titulo,
        descricao: itemSelecionado.descricao,
        dataDestaque: itemSelecionado.dataDestaque
          ? formatDateLocal(itemSelecionado.dataDestaque)
          : '',
        link: itemSelecionado.link,
        observacoes: itemSelecionado.observacoes,
        usuarioId: userID,
        tabId: parseInt(id_tab, 10),
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    if (name === 'nivelCriticidade') {
      setFormDestaque((prev: FormDestaqueType) => ({
        ...prev,
        nivelCriticidade: newValue,
      }));
    } else {
      setFormDestaque((prev: FormDestaqueType) => ({ ...prev, [name]: value }));
    }
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(formDestaque)) throw new Error('Formulário inválido.');
      const formToSend = {
        ...formDestaque,
        dataDestaque: formDestaque.dataDestaque || null,
        tabId: Number(formDestaque.tabId),
      };
      if (id_tab !== 'undefined')
        await httpClient.post(`/api/destaque?tab=${tab}`, formToSend);
      else {
        const error_message =
          'Não foi encontrado um registro para criar um Destaque.';
        CustomSwal.quick('error', error_message);
        throw new Error(error_message);
      }
      swalSave();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formDestaque)) throw new Error('Formulário inválido.');
      const formToSend = {
        ...formDestaque,
        dataDestaque: formDestaque.dataDestaque || null,
      };
      const response = await httpClient.patch(
        `/api/destaque/${destaqueId}`,
        formToSend,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(`/api/destaque/${destaqueId}`);
      swalDeleteConfirm();
      fetchData();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //////OUTRAS FUNÇÕES
  const validateForm = (form: any) => {
    const erros = [];
    if (!form.titulo) erros.push('<b>Título</b> é obrigatório.');
    if (!form.descricao) erros.push('<b>Descrição</b> é obrigatória.');
    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }
    return true;
  };

  return (
    <>
      {/* SubAbas */}
      <SubAbas>
        <StyledLink
          to={retorno}
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>
      {/*Destaque */}
      <ContainerConteudo>
        {/* Modal */}
        <CustomOffcanvas
          title={tituloModal}
          show={showModal}
          onClose={handleShowModal}
          width="70vw"
        >
          <WorkspaceFicha>
            {logData?.id ? (
              <Log {...logData} entity="TB_DESTAQUE" id={formDestaque.id} />
            ) : null}
            <BoxConteudo boxTitulo="Informações do Destaque">
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="200px">
                  <Select
                    name="nivelCriticidade"
                    value={formDestaque.nivelCriticidade}
                    options={NivelCriticidade}
                    onChange={handleChange}
                    label="Criticidade"
                    required
                  />
                </CustomCol>
                <CustomCol width="180px">
                  <Input
                    id="dataDestaque"
                    name="dataDestaque"
                    label="Data"
                    value={formDestaque.dataDestaque}
                    onChange={handleChange}
                    type="date"
                    required
                  />
                </CustomCol>
                <CustomCol>
                  <Input
                    id="titulo"
                    name="titulo"
                    value={formDestaque.titulo}
                    label="Título"
                    onChange={handleChange}
                    required
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol>
                  <Input
                    id="descricao"
                    name="descricao"
                    type="textarea"
                    value={formDestaque.descricao}
                    label="Descrição"
                    linhas={4}
                    onChange={handleChange}
                    required
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <CustomCol>
                  <Input
                    id="link"
                    name="link"
                    label="Link para mais informações"
                    value={formDestaque.link}
                    onChange={handleChange}
                    type="url"
                    onClick={() => {
                      const rawUrl = formDestaque.link?.trim();
                      if (rawUrl) {
                        let url = rawUrl;
                        if (
                          !url.startsWith('http://') &&
                          !url.startsWith('https://')
                        ) {
                          url = `https://${url}`;
                        }
                        window.open(url, '_blank', 'noopener,noreferrer');
                      }
                    }}
                    style={{
                      color: formDestaque.link ? 'blue' : 'inherit',
                      textDecoration: formDestaque.link ? 'underline' : 'none',
                      cursor: formDestaque.link ? 'pointer' : 'default',
                    }}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <Col>
                  <Input
                    id="observacoes"
                    type="textarea"
                    label="Observações"
                    name="observacoes"
                    value={formDestaque.observacoes}
                    linhas={3}
                    onChange={handleChange}
                  />
                </Col>
              </CustomRow>
              <BarraInferiorBotoes>
                {updating ? (
                  <WorkspaceBotoes
                    delete
                    onClickDelete={handleDelete}
                    save
                    onClickSave={handleUpdate}
                  />
                ) : (
                  <WorkspaceBotoes inserir onClickInserir={handleCreate} />
                )}
              </BarraInferiorBotoes>
            </BoxConteudo>
            {/* <UploadMultiple /> */}
          </WorkspaceFicha>
        </CustomOffcanvas>
        {/* Tabela */}
        <Tabela
          dataTable={tableData}
          headers={headersDestaques}
          displayValues={valoresExibidosDestaques}
          noOffCanvasTable
          onRowClick={handleRowClick}
          botaoAbrirOffCanvas={false}
        />
      </ContainerConteudo>
      {/* Barra inferior */}
      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidosDestaques,
              fieldObject,
              arquivo_export,
              userID,
              'DAF',
              entity,
            )
          }
          inserir
          onClickInserir={handleClickInserirNovo}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default DestaquesComponente;
